var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-search',_vm._g(_vm._b({staticClass:"base_search",scopedSlots:_vm._u([{key:"left-icon",fn:function(){return [_c('img',{staticClass:"left_icon",attrs:{"src":require("../../../assets/icon/search.png")}})]},proxy:true}])},'van-search',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }